var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.valid)?_c('v-btn',{attrs:{"color":"secondary","rounded":"","depressed":"","x-small":""},on:{"click":_vm.handler}},[_vm._v("Tax Exempt")]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }